import { SxProps, Theme } from "@mui/material";
import { GridColDef, GridSortModel } from "@mui/x-data-grid-premium";
import { GridApiPremium } from "@mui/x-data-grid-premium/models/gridApiPremium";
import React from "react";

import { DataGrid as MUIDataGrid } from "@/Components/v2/organism/DataGrid";
import { FlightingGridRow } from "@/pages/flighting/components/DataGrid/adapter";

import { GridColumnDefinition, GridRow } from "./adapter";

interface DataGridProps {
  apiRef: React.MutableRefObject<GridApiPremium>;
  toolbarComponent: React.ReactNode;
  theme: Theme;
  rows: GridRow[] | FlightingGridRow[];
  columns: GridColumnDefinition[] | GridColDef[];
  rowHeight?: number;
  sortModel?: GridSortModel;
  sxProps?: SxProps<Theme>;
}

export const DataGrid: React.FC<DataGridProps> = ({
  apiRef,
  toolbarComponent,
  rows,
  columns,
  rowHeight = 52,
  sortModel = [],
  sxProps = {},
}) => {
  if (!rows.length) {
    return null;
  }

  return (
    <MUIDataGrid
      sx={{ border: "none", position: "relative", ...sxProps } as any}
      apiRef={apiRef}
      disableColumnFilter
      disableColumnMenu
      disableColumnSelector
      disableRowSelectionOnClick
      disableMultipleRowSelection
      rowHeight={rowHeight}
      rows={rows}
      columns={columns}
      pagination
      autosizeOnMount
      slots={{ toolbar: () => <>{toolbarComponent}</> }}
      initialState={{
        pagination: {
          paginationModel: { pageSize: 25 },
        },
        sorting: {
          sortModel: sortModel,
        },
      }}
    />
  );
};
